(function () {
  'use strict';

  var INKYBAY_PROPERTY_PREFIX = '_inkybay_';
  var SOURCE_URL_PROPERTY = '_source_product_url';
  var SOURCE_STORAGE_KEY = 'inkybay_source_product_url';

  function getCurrentProductUrl() {
    if (!/^\/products\/[^/?#]+/.test(window.location.pathname)) {
      return '';
    }

    return window.location.pathname + window.location.search;
  }

  function saveCurrentProductUrl() {
    var productUrl = getCurrentProductUrl();

    if (productUrl) {
      sessionStorage.setItem(SOURCE_STORAGE_KEY, productUrl);
    }
  }

  function isInkybayItem(properties) {
    if (!properties) return false;

    return Object.keys(properties).some(function (key) {
      return key.indexOf(INKYBAY_PROPERTY_PREFIX) === 0;
    });
  }

  function getSourceUrl() {
    var storedUrl = sessionStorage.getItem(SOURCE_STORAGE_KEY);

    if (storedUrl) return storedUrl;

    var match = document.referrer.match(
      /^https?:\/\/[^/]+(\/products\/[^/?#]+(?:\?[^#]*)?)/
    );

    return match ? match[1] : '';
  }

  function tagSourceUrl(cart) {
    var sourceUrl = getSourceUrl();
    if (!sourceUrl) return Promise.resolve();

    var untagged = cart.items.filter(function (item) {
      return (
        isInkybayItem(item.properties) &&
        !item.properties[SOURCE_URL_PROPERTY]
      );
    });

    if (untagged.length !== 1) return Promise.resolve();

    var item = untagged[0];
    var properties = {};

    Object.keys(item.properties || {}).forEach(function (key) {
      properties[key] = item.properties[key];
    });

    properties[SOURCE_URL_PROPERTY] = sourceUrl;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        properties: properties
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to save source product URL');
        }

        sessionStorage.removeItem(SOURCE_STORAGE_KEY);
      })
      .catch(function (error) {
        console.error('InkyBay source URL error:', error);
      });
  }

  function fixCartLinks(cart) {
    cart.items.forEach(function (item) {
      if (!isInkybayItem(item.properties)) return;

      var sourceUrl = item.properties[SOURCE_URL_PROPERTY];
      if (!sourceUrl) return;

      document.querySelectorAll('a').forEach(function (link) {
        var href = link.getAttribute('href') || '';

        if (
          href.indexOf('/products/') !== -1 &&
          href.indexOf(item.handle) !== -1
        ) {
          link.setAttribute('href', sourceUrl);
        }
      });
    });
  }

  function run() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(tagSourceUrl)
      .then(function () {
        return fetch('/cart.js').then(function (response) {
          return response.json();
        });
      })
      .then(fixCartLinks)
      .catch(function (error) {
        console.error('InkyBay cart redirect error:', error);
      });
  }

  saveCurrentProductUrl();

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:refresh', run);
})();